import React, { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { Modal, notification } from 'antd'
import {
  CREATE_SCRAPING_TAG,
  UPDATE_SCRAPING_TAG,
} from '../../../graphql/mutations'
import { ScrapingTagEditorForm } from '../../forms'
import PropTypes from 'prop-types'

const ScrapingTagEditorModal = ({
  tag,
  refetchScrapingTags,
  isModalOpen,
  closeModal,
}) => {
  const [createScrapingTag, { loading: isCreatingTag }] = useMutation(
    CREATE_SCRAPING_TAG,
    {
      onCompleted() {
        refetchScrapingTags()
        closeModal()
        notification.open({
          message: 'Scraping tag was created.',
          type: 'success',
        })
      },
      onError({ message }) {
        notification.open({
          message: 'Faled to create scraping tag.',
          description: message,
          type: 'error',
          duration: 0,
        })
      },
    },
  )

  const [updateScrapingTag, { loading: isUpdatingTag }] = useMutation(
    UPDATE_SCRAPING_TAG,
    {
      onCompleted() {
        refetchScrapingTags()
        closeModal()
        notification.open({
          message: 'Scraping tag was updated.',
          type: 'success',
        })
      },
      onError({ message }) {
        notification.open({
          message: 'Faled to update scraping tag.',
          description: message,
          type: 'error',
          duration: 0,
        })
      },
    },
  )

  const handleSubmit = useCallback(
    tag =>
      tag.id
        ? updateScrapingTag({ variables: tag })
        : createScrapingTag({ variables: { name: tag.name } }),
    [createScrapingTag, updateScrapingTag],
  )

  return (
    <Modal
      title={tag ? 'Edit tag' : 'Create tag'}
      visible={isModalOpen}
      footer={null}
      onCancel={closeModal}
      destroyOnClose
    >
      <ScrapingTagEditorForm
        tag={tag}
        onSubmit={handleSubmit}
        isSubmitting={isCreatingTag || isUpdatingTag}
        closeModal={closeModal}
      />
    </Modal>
  )
}

ScrapingTagEditorModal.propTypes = {
  tag: PropTypes.object,
  refetchScrapingTags: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
}

ScrapingTagEditorModal.defaultProps = {
  tag: undefined,
}

export default ScrapingTagEditorModal
